module.exports = __webpack_public_path__ + "static/media/warton_sc.e9618415.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/paratrioza/curativa/warton_sc.png
// module id = 2007
// module chunks = 3